module.exports = {
          srcSet: __webpack_public_path__ + "367a9bdbf3cdd3bda2c79a87eec5aa64-450.png"+" 450w",
          images:[ {path: __webpack_public_path__ + "367a9bdbf3cdd3bda2c79a87eec5aa64-450.png",width: 450,height: 47}],
          src: __webpack_public_path__ + "367a9bdbf3cdd3bda2c79a87eec5aa64-450.png",
          toString:function(){return __webpack_public_path__ + "367a9bdbf3cdd3bda2c79a87eec5aa64-450.png"},
          
          width: 450,
          height: 47
        }